import script from "./StudentReleaseConfirmDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentReleaseConfirmDialog.vue?vue&type=script&setup=true&lang=js"

import "./StudentReleaseConfirmDialog.vue?vue&type=style&index=0&id=2f627e75&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f627e75"]])

export default __exports__